import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Wraps a PDP specifications dropdown body (curaprox-attr-list output). The spec
 * rows are resolved variant-first (per-variant PIM custom fields sync as VARIANT
 * metafields — see snippets/curaprox-attr-list.liquid), but on a variant switch
 * the theme only morphs the variant picker itself; every other region updates by
 * consuming the freshly rendered section HTML from the VariantUpdateEvent. This
 * element swaps its own body from that HTML, mirroring `product-title-aroma.js`.
 *
 * `data-source` (specifications / weitere_informationen / specifications_combined)
 * pairs each instance with its counterpart in the response — the PDP renders one
 * dropdown per source, so the pair is unambiguous.
 *
 * @extends {Component}
 */
class CuraproxVariantSpecs extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecs);
  }

  /**
   * Replaces the spec list with the version rendered for the newly selected variant.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateSpecs = (event) => {
    const source = this.dataset.source;
    if (!source) return;

    const counterpart = event.detail.data.html.querySelector(
      `curaprox-variant-specs[data-source="${source}"]`
    );
    // A missing counterpart means the section render dropped the whole dropdown
    // (blank-gated) — keep the current rows rather than blanking a visible list.
    if (!counterpart) return;

    this.replaceChildren(...counterpart.childNodes);
  };
}

if (!customElements.get('curaprox-variant-specs')) {
  customElements.define('curaprox-variant-specs', CuraproxVariantSpecs);
}
